import React, { useState, useEffect } from 'react'
import { login, recordFailedAttempt, clearFailedAttempts, getLockoutStatus } from '../../utils/auth'

const AdminLogin = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  })
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [lockout, setLockout] = useState({ locked: false, minutesLeft: 0, count: 0 })

  useEffect(() => {
    setLockout(getLockoutStatus())
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const MAX_ATTEMPTS = 5

  const handleSubmit = async (e) => {
    e.preventDefault()
    const status = getLockoutStatus()
    if (status.locked) {
      setLockout(status)
      return
    }
    setIsLoading(true)
    setError('')

    try {
      await login(credentials.username, credentials.password)
      clearFailedAttempts()
      onLogin()
    } catch {
      const result = recordFailedAttempt()
      const remaining = MAX_ATTEMPTS - result.count
      if (result.locked) {
        setLockout({ locked: true, minutesLeft: 15, count: result.count })
        setError('Too many failed attempts. Locked out for 15 minutes.')
      } else {
        setError(`Invalid credentials. ${remaining} attempt${remaining !== 1 ? 's' : ''} remaining.`)
        setLockout(getLockoutStatus())
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="admin-login">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <h1>TalentHouse Admin</h1>
            <p>Sign in to manage job listings</p>
          </div>

          <form onSubmit={handleSubmit} className="admin-login-form">
            {lockout.locked ? (
              <div className="admin-login-error">
                <i className="fas fa-lock"></i> Account locked. Try again in {lockout.minutesLeft} minute{lockout.minutesLeft !== 1 ? 's' : ''}.
              </div>
            ) : error ? (
              <div className="admin-login-error">
                {error}
              </div>
            ) : null}

            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                name="username"
                value={credentials.username}
                onChange={handleChange}
                required
                placeholder="Enter username"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                required
                placeholder="Enter password"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-large"
              disabled={isLoading || lockout.locked}
            >
              {isLoading ? (
                <>
                  <div className="spinner"></div>
                  Signing in...
                </>
              ) : (
                'Sign In'
              )}
            </button>
          </form>

          <div className="admin-login-footer">
            <p>TalentHouse Admin Portal</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminLogin
